import React, { Component } from "react";

import { createStore } from "redux";
import { BrowserRouter as Router, Route } from "react-router-dom";

import "./css/from_starter_kit/sk.main.local.css"
import "./css/App.css";

import cuentas from "./reducers";

import loadable from "@loadable/component";

import Measure from "react-measure";

const PasoInicio = loadable(() => import(/* webpackChunkName: "Inicio" */ "./pages/PasoInicio"));
const PasoEleccionCuenta = loadable(() => import(/* webpackChunkName: "EleccionCuenta" */ "./pages/PasoEleccionCuenta"));
const PasoTerminosyCondicionesDigital = loadable(() => import(/* webpackChunkName: "TerminosCondiciones" */ "./pages/PasoTerminosyCondicionesDigital"));
const SuccessfulAccountDigital = loadable(() => import(/* webpackChunkName: "SuccessfulAccount" */ "./pages/SuccessfulAccountDigital"));
const PaginaError = loadable(() => import(/* webpackChunkName: "Error" */ "./pages/PaginaError"));

// Flujo cuenta Emprendedor:
const PasoInicioCuentaEmprendedor = loadable(() => import(/* webpackChunkName: "InicioCE" */ "./pages/CuentaEmprendedor/PasoInicioCuentaEmprendedor"));
const PasoEleccionCuentaEmprendedor = loadable(() => import(/* webpackChunkName: "EleccionCE" */ "./pages/CuentaEmprendedor/PasoEleccionCuentaEmprendedor"));
const PasoIdentidadCuentaEmprendedor = loadable(() => import(/* webpackChunkName: "IdentidadCE" */ "./pages/CuentaEmprendedor/PasoIdentidadCuentaEmprendedor"));
const PasoTerminosyCondicionesCuentaEmprendedor = loadable(() => import(/* webpackChunkName: "TerminosCondicionesCE" */ "./pages/CuentaEmprendedor/PasoTerminosyCondicionesCuentaEmprendedor"));
const PasoFinalCuentaEmprendedor = loadable(() => import(/* webpackChunkName: "FinalCE" */ "./pages/CuentaEmprendedor/PasoFinalCuentaEmprendedor"));
const PaginaErrorCuentaEmprendedor = loadable(() => import(/* webpackChunkName: "ErrorCE" */ "./pages/CuentaEmprendedor/PaginaErrorCuentaEmprendedor"));


let store = createStore(cuentas);

class App extends Component {
  constructor(props) {
    super(props);
    this.calcHeight = this.calcHeight.bind(this);
    this.state = {
      dimensions: {
        width: -1,
        height: -1,
      },
    };
  }

  render() {

    let CONTEXT = '/cuentas/';
    let CONTEXT_CE = '/cuentas/cuenta-emprendedor/';
    let contexAjax = '/cuentas/';

    // Subdominio
    if (window.location.host === 'cuentas.bbva.pe') {
      CONTEXT = '/';
      CONTEXT_CE = '/cuenta-emprendedor/';
      contexAjax = '/';
    // Otros (Extranet, localhost, etc.)
    } else { 
        CONTEXT = '/cuentas/';
        CONTEXT_CE = '/cuentas/cuenta-emprendedor/';
        contexAjax = '/cuentas/';
    }

    return (
      <Measure
        bounds
        onResize={(contentRect) => {
          this.setState({ dimensions: contentRect.bounds });
          this.calcHeight(contentRect.bounds.height);
        }}
      >
        {({ measureRef }) => (
          <div style={divApp} ref={measureRef}>
            <Router>
              <div>
                <Router>
                  <div>
                    <Route exact path={CONTEXT} render={(props) => <PasoInicio {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "pasoEleccionCuenta"} render={(props) => <PasoEleccionCuenta {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "terminos-y-condiciones-digital"} render={(props) => <PasoTerminosyCondicionesDigital {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "pasoFinDigital"} render={(props) => <SuccessfulAccountDigital {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "error"} render={(props) => <PaginaError {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />

                    {/* Flujo Cuenta Emprendedor */}
                    <Route exact path={CONTEXT_CE} render={(props) => <PasoInicioCuentaEmprendedor {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "pasoEleccionCE"} render={(props) => <PasoEleccionCuentaEmprendedor {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route exact path={CONTEXT + "pasoIdentidadCE"} render={(props) => <PasoIdentidadCuentaEmprendedor {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route exact path={CONTEXT + "pasoTerminosCE"} render={(props) => <PasoTerminosyCondicionesCuentaEmprendedor {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "pasoFinalCE"} render={(props) => <PasoFinalCuentaEmprendedor {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "paginaErrorCE"} render={(props) => <PaginaErrorCuentaEmprendedor {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                  </div>
                </Router>
              </div>
            </Router>
          </div>
        )}
      </Measure>
    );
  }

  calcHeight(height) {
    const inIframe =  window.self !== window.top;

    if (inIframe) {
      try {
        // Usar postMessage para comunicarse de manera segura con el padre
        window.parent.postMessage({
          type: 'resize-iframe',
          height: height,
          origin: 'cuentas-app'
        }, '*');
      } catch (e) {
        console.error("Error al enviar mensaje:", e);
      }
    }
  }
}

const divApp = {
  margin: "auto",
};

export default App;
